import { useEffect, useState } from "react";

const ValidationError = ({ errorMessage, trigger }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!errorMessage) return;

    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [errorMessage, trigger]); // 👈 trigger is key

  if (!visible) return null;

  return (
    <div className="mt-3 flex items-start gap-2 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-600">
      <svg
        className="h-5 w-5 text-red-500 mt-0.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>

      <p>{errorMessage}</p>
    </div>
  );
};

export default ValidationError;
